import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Country, State } from "country-state-city";
import {
  getUserDetails,
  updateUserProfileInfo,
} from "../../store/AuthSlice/thunk";
import { getDropDownList } from "../../store/PeopleSlice/thunk";
import {
  biographyFields,
  bloodGroups,
  commonFields,
  genders,
} from "../../constants/people";
import { authActions } from "../../store/AuthSlice";
import CustomInput from "../../commonComponents/CustomInput";
import CustomDropdown from "../../commonComponents/CustomDropdown";
import AvatarIcon from "../../assets/icons/person.svg";
import GroupIcon from "../../assets/icons/groups.svg";
import UpdateInfo from "../../assets/icons/person_edit.svg";
import Done from "../../assets/icons/done_all_white.svg";
import Cancel from "../../assets/icons/close_white.svg";
import India from "../../assets/images/india.png";
import EyeIcon from "../../assets/icons/visibility.svg";
import EyeIconOff from "../../assets/icons/visibility_off.svg";
import ArrowbackIcon from "../../assets/icons/arrow_back.svg";

import "./Profile.css";
import InitialsCircle from "../../components/InitialsCircle";

const Profile = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [updateInfo, setUpdateInfo] = useState(false);
  const [personalEmailID, setPersonalEmailID] = useState("");
  const [personalMobileNumber, setPersonalMobileNumber] = useState("");
  const [fullName, setFullName] = useState("");
  const [fathersName, setFathersName] = useState("");
  const [gender, setGender] = useState("");
  const [bloodGroup, setBloodGroup] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [nationality, setNationality] = useState("");
  const [marriageAnniversary, setMarriageAnniversary] = useState("");
  const [maritalStatus, setMaritalStatus] = useState("");
  const [addressLine1, setAddressLine1] = useState("");
  const [addressLine2, setAddressLine2] = useState("");
  const [addressPincode, setAddressPincode] = useState("");
  const [addressCity, setAddressCity] = useState("");
  const [addressState, setAddressState] = useState("");
  const [addressCountry, setAddressCountry] = useState("");
  const [jobDetails, setJobDetails] = useState([]);
  const [isValidError, setIsValidError] = useState(false);
  const [maskBankDetails, setMaskBankDetails] = useState(true);

  const profileTabSelected = useSelector(
    (state) => state.auth.profileTabSelected,
  );

  const userDetailsResponse = useSelector(
    (state) => state.auth.userDetailsResponse,
  );

  const updateProfileInfoResponseStatus = useSelector(
    (state) => state.auth.updateProfileInfoResponseStatus,
  );

  const roleType = useSelector(
    (state) => state.auth?.loginResponse?.body?.role_type,
  );

  const userDetailsResponseStatus = useSelector(
    (state) => state.auth.userDetailsResponseStatus,
  );

  const employeeID = useSelector((state) => state.auth.employeeID);

  const dropDownData =
    useSelector((state) => state?.people?.dropDownListResponse?.data) || {};

  useEffect(() => {
    dispatch(getDropDownList({}));
    return () => {
      console.log("\n\nreset user details");

      dispatch(authActions.resetUserDetails());
    };
  }, []);

  useEffect(() => {
    if (userDetailsResponseStatus === "SUCCESS") {
      setPersonalEmailID(
        userDetailsResponse?.user_details?.personal_email_id?.value,
      );
      setPersonalMobileNumber(
        userDetailsResponse?.user_details?.personal_mobile_no?.value,
      );
      setFullName(userDetailsResponse?.user_details?.full_name?.value);
      setFathersName(userDetailsResponse?.user_details?.fathers_name?.value);
      setGender(userDetailsResponse?.user_details?.gender?.value);
      setBloodGroup(userDetailsResponse?.user_details?.blood_group?.value);
      setDateOfBirth(userDetailsResponse?.user_details?.date_of_birth?.value);
      setNationality(userDetailsResponse?.user_details?.nationality?.value);
      setMarriageAnniversary(
        userDetailsResponse?.user_details?.anniversary_date?.value,
      );
      setMaritalStatus(
        userDetailsResponse?.user_details?.marital_status?.value,
      );
      // setAddress(userDetailsResponse?.user_details?.address?.value);
      setAddressLine1(userDetailsResponse?.user_details?.line_1_address?.value);
      setAddressLine2(userDetailsResponse?.user_details?.line_2_address?.value);
      setAddressPincode(userDetailsResponse?.user_details?.pincode?.value);

      let country = getCountryDetails(
        userDetailsResponse?.user_details?.address_country?.value,
      );
      setAddressCountry(country);

      let state = getStateDetails(
        country,
        userDetailsResponse?.user_details?.state?.value,
      );
      setAddressState(state);

      // let city = getCityDetails(country, state, userDetailsResponse?.user_details?.city?.value)
      setAddressCity(userDetailsResponse?.user_details?.city?.value);

      console.log("\n\n\n\n\ncountry", country);
      console.log("state", state);
      // console.log('city', city);

      setJobDetails(
        userDetailsResponse?.user_details?.job_history?.value || [],
      );
    } else if (userDetailsResponseStatus === "ERROR") {
    }
  }, [userDetailsResponseStatus]);

  useEffect(() => {
    if (updateProfileInfoResponseStatus === "SUCCESS") {
      setUpdateInfo(false);

      dispatch(
        getUserDetails({
          employee_id: employeeID,
          user_type: roleType,
        }),
      );
    } else if (updateProfileInfoResponseStatus === "ERROR") {
    }
  }, [updateProfileInfoResponseStatus]);

  const handleUpdateInfo = () => {
    setIsValidError(false);
    const userDetails = userDetailsResponse?.user_details;

    console.log("\nuserDetails :", userDetails);

    const data = {};
    let hasValidationError = false;

    for (const key in userDetails) {
      if (userDetails.hasOwnProperty(key)) {
        if (userDetails[key].editable === true) {
          switch (key) {
            case "personal_email_id":
              data[key] = personalEmailID || null;
              if (!personalEmailID) hasValidationError = true;
              break;
            case "personal_mobile_no":
              data[key] = personalMobileNumber || null;
              if (!personalMobileNumber) hasValidationError = true;
              break;
            case "full_name":
              data[key] = fullName || null;
              if (!fullName) hasValidationError = true;
              break;
            case "fathers_name":
              data[key] = fathersName || null;
              if (!fathersName) hasValidationError = true;
              break;
            case "gender":
              data[key] = gender || null;
              if (!gender) hasValidationError = true;
              break;
            case "blood_group":
              data[key] = bloodGroup || null;
              if (!bloodGroup) hasValidationError = true;
              break;
            case "date_of_birth":
              data[key] = dateOfBirth || null;
              if (!dateOfBirth) hasValidationError = true;
              break;
            case "nationality":
              data[key] = nationality || null;
              if (!nationality) hasValidationError = true;
              break;
            case "anniversary_date":
              data[key] = marriageAnniversary || null;
              if (!marriageAnniversary) hasValidationError = true;
              break;
            case "marital_status":
              data[key] = maritalStatus || null;
              if (!maritalStatus) hasValidationError = true;
              break;
            case "line_1_address":
              data[key] = addressLine1 || null;
              if (!addressLine1) hasValidationError = true;
              break;
            case "line_2_address":
              data[key] = addressLine2 || null;
              if (!addressLine2) hasValidationError = true;
              break;
            case "pincode":
              data[key] = addressPincode || null;
              if (!addressPincode) hasValidationError = true;
              break;
            case "city":
              data[key] = addressCity || null;
              if (!addressCity) hasValidationError = true;
              break;
            case "state":
              data[key] = addressState?.name || null;
              if (!addressState?.name) hasValidationError = true;
              break;
            case "address_country":
              data[key] = addressCountry?.name || null;
              if (!addressCountry?.name) hasValidationError = true;
              break;
            default:
              console.warn(`Unhandled key: ${key}`);
              data[key] = null;
              break;
          }
        }
      }
    }

    console.log("\n\n\n\ndata", data);

    if (hasValidationError) {
      setIsValidError(true);
      return;
    }

    const payload = {
      employee_id: employeeID,
      user_type: roleType,
      data: { ...data },
    };

    dispatch(updateUserProfileInfo(payload));
    return;
  };

  const getCountryDetails = (countryName) => {
    console.log("\n1getCountryDetails", countryName);

    const country = Country.getAllCountries().find(
      (c) => c.name === countryName,
    );
    console.log("country", country);

    return country ? { ...country } : { isoCode: "", name: "" };
  };

  const getStateDetails = (countryName, stateName) => {
    console.log("\n2getCountryDetails", countryName);
    console.log("2getStateDetails", stateName);

    const state = State.getStatesOfCountry(countryName.isoCode).find(
      (s) => s.name === stateName,
    );

    return state ? { ...state } : { isoCode: "", name: "" };
  };

  const InfoInput = useCallback(
    ({
      updateInfo,
      value = "",
      placeholder = "",
      editable = true,
      onChange = () => {},
      parentClass = "",
      styles = { width: "100%" },
      validationString,
      errorLabel = "",
      isValidError = false,
    }) => {
      // console.log('\nplaceholder', placeholder);

      // console.log('value', value);

      return (
        <div className="pr-pf-detail-box">
          {updateInfo && editable ? (
            <>
              <div className="pr-pf-detail-label text-black flex-wrap">
                {placeholder}
              </div>
              {/* <div className="pr-pf-input-box"> */}
              <CustomInput
                value={value}
                placeholder={placeholder}
                editable={editable}
                onChange={onChange}
                styles={styles}
                validationStr={validationString}
                errorlabel={errorLabel}
                isRequired={editable}
                isError={isValidError}
              />
              {/* </div> */}
            </>
          ) : (
            <>
              <div className="pf-label">{placeholder}</div>
              <div className="pf-value">{value || "NA"}</div>
            </>
          )}
        </div>
      );
    },
    [],
  );

  const InfoDropdown = useCallback(
    ({
      updateInfo,
      value = "",
      placeholder = "",
      editable = true,
      onSelect = () => {},
      parentClass = "",
      styles = { width: "100%" },
      options,
      isObjectDrop,
      keyName,
      isValidError = false,
    }) => {
      return (
        <div className="pr-pf-detail-box">
          {updateInfo && editable ? (
            <>
              <div className="pr-pf-input-box">
                <CustomDropdown
                  className="emp-form-dropdown"
                  options={options}
                  value={value}
                  onSelectOption={onSelect}
                  isRequired={editable}
                  label={placeholder}
                  isObjectDrop={isObjectDrop}
                  keyName={isObjectDrop && keyName}
                  isError={isValidError}
                />
              </div>
            </>
          ) : (
            <>
              <div className="pf-label">{placeholder}</div>
              <div className="pf-value">{value}</div>
            </>
          )}
        </div>
      );
    },
    [],
  );

  const hideBankDetails = useCallback(() => {
    setMaskBankDetails(!maskBankDetails);
  }, [maskBankDetails]);

  const MaskedText = ({ text, flag }) => {
    if (!text) return "NA";
    let showValueLength = 4;
    if (text.length <= 4) {
      showValueLength = 2;
    }
    const maskedText = text.replace(
      new RegExp(`.(?=.{${showValueLength}})`, "g"),
      "*",
    );
    if (flag) {
      return <span>{maskedText}</span>;
    } else {
      return <span>{text}</span>;
    }
  };

  return (
    <div className="p-12">
      <div className="xl:hidden mb-3">
        <button
          type="button"
          aria-label="Back to all modules"
          className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-slate-100 border-0"
          onClick={() => navigate("../all")}
        >
          <img src={ArrowbackIcon} alt="Back" className="h-5 w-5" />
        </button>
      </div>
      {profileTabSelected === "overview" && (
        <div className="flex flex-col">
          <div className="profile-header">
            {/* <img src={AvatarIcon} className="pf-user-ico" alt="" /> */}
            <InitialsCircle
              fullName={userDetailsResponse?.user_details?.full_name?.value}
              size={72}
              type="profile"
            />
            <div className="flex flex-col">
              <div className="flex items-center mb-12">
                <div className="pf-user-name">
                  {userDetailsResponse?.user_details?.full_name?.value}
                </div>
                <div className="pf-user-status">
                  {userDetailsResponse?.user_details?.confirmation_status
                    ?.value || "NA"}
                </div>
              </div>
              <div className="pf-user-design">
                <img src={GroupIcon} />
                {userDetailsResponse?.user_details?.business_unit?.value ||
                  "NA"}
              </div>
            </div>
          </div>

          <div className="pf-details mt-20">
            <div className="pf-detail-box">
              <div className="pf-label">Employee ID</div>
              <div className="pf-value">
                {userDetailsResponse?.user_details?.employee_id?.value || "NA"}
              </div>
            </div>
            <div className="pf-detail-box">
              <div className="pf-label">Designation</div>
              <div className="pf-value">
                {userDetailsResponse?.user_details?.designation?.value || "NA"}
              </div>
            </div>
            <div className="pf-detail-box">
              <div className="pf-label">Email ID</div>
              <div className="pf-value">
                {userDetailsResponse?.user_details?.personal_email_id?.value ||
                  "NA"}
              </div>
            </div>
            <div className="pf-detail-box">
              <div className="pf-label">Business Unit</div>
              <div className="pf-value">
                {userDetailsResponse?.user_details?.business_unit?.value ||
                  "NA"}
              </div>
            </div>
            <div className="pf-detail-box">
              <div className="pf-label">Joining Date</div>
              <div className="pf-value">
                {userDetailsResponse?.user_details?.date_of_joining?.value ||
                  "NA"}
              </div>
            </div>
            <div className="pf-detail-box">
              <div className="pf-label">Office Location</div>
              <div className="pf-value">
                {userDetailsResponse?.user_details?.base_office_location
                  ?.value || "NA"}
              </div>
            </div>

            <div className="pf-detail-box">
              <div className="pf-label">HOD</div>
              <div className="pf-value">
                {" "}
                {userDetailsResponse?.user_details?.business_unit_head?.value ||
                  "NA"}
              </div>
            </div>
            <div className="pf-detail-box">
              <div className="pf-label">HRBP Role</div>
              <div className="pf-value">
                {" "}
                {userDetailsResponse?.user_details?.hrbp_name?.value || "NA"}
              </div>
            </div>
            <div className="pf-detail-box">
              <div className="pf-label">Office Location Cost Center</div>
              <div className="pf-value">
                {userDetailsResponse?.user_details?.cost_center?.value || "NA"}
              </div>
            </div>
            <div className="pf-detail-box">
              <div className="pf-label">Personal Mobile Number</div>
              <div className="pf-value">
                {userDetailsResponse?.user_details?.personal_mobile_no?.value ||
                  "NA"}
              </div>
            </div>
          </div>

          <div className="pf-job flex flex-col mt-20">
            <div className="pf-detail-head">
              Bank Details
              <div className="eye-icon-box">
                <img
                  className="eye-icon"
                  src={maskBankDetails ? EyeIconOff : EyeIcon}
                  alt=""
                  onClick={hideBankDetails}
                />
              </div>
            </div>
            <div className="pf-details">
              <div className="pf-detail-box">
                <div className="pf-label">Name of Account Holder</div>
                <div className="pf-value">
                  <MaskedText
                    text={userDetailsResponse?.bank_details?.name_account}
                    flag={maskBankDetails}
                  />
                </div>
              </div>
              <div className="pf-detail-box">
                <div className="pf-label">Account Number</div>
                <div className="pf-value">
                  <MaskedText
                    text={userDetailsResponse?.bank_details?.account_number}
                    flag={maskBankDetails}
                  />
                </div>
              </div>
              <div className="pf-detail-box">
                <div className="pf-label">Bank Name</div>
                <div className="pf-value">
                  <MaskedText
                    text={userDetailsResponse?.bank_details?.bank_name}
                    flag={maskBankDetails}
                  />
                </div>
              </div>
              <div className="pf-detail-box">
                <div className="pf-label">Bank Branch</div>
                <div className="pf-value">
                  <MaskedText
                    text={userDetailsResponse?.bank_details?.branch_name}
                    flag={maskBankDetails}
                  />
                </div>
              </div>
              <div className="pf-detail-box">
                <div className="pf-label">Swift / IFSC Code</div>
                <div className="pf-value">
                  <MaskedText
                    text={userDetailsResponse?.bank_details?.ifsc_code}
                    flag={maskBankDetails}
                  />
                </div>
              </div>
              <div className="pf-detail-box">
                <div className="pf-label">Account Type</div>
                <div className="pf-value">
                  <MaskedText
                    text={userDetailsResponse?.bank_details?.account_type}
                    flag={maskBankDetails}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {profileTabSelected === "personal" && (
        <div className="flex flex-col pr-personal">
          <div className="pf-pr-box">
            <div className="pf-pr-head">
              <div className="pf-pr-text">Biographical</div>
              <div className="update-btn-group">
                {!updateInfo ? (
                  <button
                    className="pf-pr-btn"
                    onClick={() => {
                      setUpdateInfo(true);
                    }}
                  >
                    <img src={UpdateInfo} alt="" className="mr-2" />
                    Update Info
                  </button>
                ) : (
                  <>
                    <button
                      className="pf-pr-btn cancel-btn"
                      onClick={() => {
                        setUpdateInfo(false);
                      }}
                    >
                      <img src={Cancel} alt="" className="mr-2" />
                      Cancel
                    </button>
                    <button
                      className="pf-pr-btn update-btn"
                      onClick={handleUpdateInfo}
                    >
                      <img src={Done} alt="" className="mr-2" />
                      Update
                    </button>
                  </>
                )}
              </div>
            </div>
            <div className="pr-pf-detail-table">
              <div className="flex w-full">
                <InfoInput
                  updateInfo={updateInfo}
                  editable={
                    userDetailsResponse?.user_details?.full_name?.editable
                  }
                  value={fullName}
                  placeholder="Full Name"
                  styles={{ width: "100%" }}
                  onChange={(value) => {
                    setFullName(value);
                  }}
                  isValidError={isValidError && !fullName}
                />

                <InfoInput
                  updateInfo={updateInfo}
                  editable={
                    userDetailsResponse?.user_details?.fathers_name?.editable
                  }
                  value={fathersName}
                  placeholder="Father's Name"
                  styles={{ width: "100%" }}
                  onChange={(value) => {
                    setFathersName(value);
                  }}
                  validationString={biographyFields?.fathers_name?.regex}
                  errorLabel="Father's Name"
                  isValidError={isValidError && !fathersName}
                />

                <InfoDropdown
                  options={genders}
                  updateInfo={updateInfo}
                  editable={userDetailsResponse?.user_details?.gender?.editable}
                  value={gender}
                  placeholder="Gender"
                  styles={{ width: "100%" }}
                  onSelect={(value) => {
                    setGender(value);
                  }}
                  isValidError={isValidError && !gender}
                />

                <InfoDropdown
                  options={bloodGroups}
                  updateInfo={updateInfo}
                  editable={
                    userDetailsResponse?.user_details?.blood_group?.editable
                  }
                  value={bloodGroup}
                  placeholder="Blood Group"
                  styles={{ width: "100%" }}
                  onSelect={(value) => {
                    setBloodGroup(value);
                  }}
                  isValidError={isValidError && !bloodGroup}
                />
              </div>
              <div className="flex  w-full">
                <InfoInput
                  updateInfo={updateInfo}
                  editable={
                    userDetailsResponse?.user_details?.date_of_birth?.editable
                  }
                  value={dateOfBirth}
                  placeholder="Date of Birth (As per Aadhaar) *"
                  styles={{ width: "100%" }}
                  onChange={(value) => {
                    setDateOfBirth(value);
                  }}
                  errorLabel="Date of Birth"
                  validationString={
                    commonFields?.user_details?.date_of_birth?.regex
                  }
                  isValidError={isValidError && !dateOfBirth}
                />
                <InfoInput
                  updateInfo={updateInfo}
                  editable={
                    userDetailsResponse?.user_details?.nationality?.editable
                  }
                  value={nationality}
                  placeholder="Nationality"
                  styles={{ width: "100%" }}
                  onChange={(value) => {
                    setNationality(value);
                  }}
                  errorLabel="Nationality"
                  validationString={
                    commonFields?.user_details?.nationality?.regex
                  }
                  isValidError={isValidError && !nationality}
                />
                <InfoInput
                  updateInfo={updateInfo}
                  editable={
                    userDetailsResponse?.user_details?.anniversary_date
                      ?.editable
                  }
                  value={marriageAnniversary}
                  placeholder="Marriage Anniversary Date"
                  styles={{ width: "100%" }}
                  onChange={(value) => {
                    setMarriageAnniversary(value);
                  }}
                  errorLabel="Marriage Anniversary Date"
                  validationString={
                    commonFields?.user_details?.anniversary_date?.regex
                  }
                  isValidError={isValidError && !marriageAnniversary}
                />

                <InfoDropdown
                  options={dropDownData?.maritalStatus || []}
                  updateInfo={updateInfo}
                  editable={
                    userDetailsResponse?.user_details?.marital_status?.editable
                  }
                  value={maritalStatus}
                  placeholder="Marital Status"
                  styles={{ width: "100%" }}
                  onSelect={(value) => {
                    setMaritalStatus(value);
                  }}
                  isValidError={isValidError && !maritalStatus}
                />
              </div>
            </div>
          </div>
          <div className="pf-pr-box">
            <div className="pf-pr-head">
              <div className="pf-pr-text">Contact Details</div>
            </div>

            {!updateInfo ? (
              <div className="pr-pf-detail-table">
                <div className="flex w-full justify-between">
                  <div className="pr-pf-detail-box w-full">
                    <div className="pr-pf-detail-label">Personal Email ID </div>
                    <div className="pr-pf-detail-value">
                      {userDetailsResponse?.user_details?.personal_email_id
                        ?.value || "NA"}
                    </div>
                  </div>
                  <div className="pr-pf-detail-box w-full">
                    <div className="pr-pf-detail-label">
                      Personal Mobile Number{" "}
                    </div>
                    <div className="pr-pf-detail-value">
                      {userDetailsResponse?.user_details?.personal_mobile_no
                        ?.value || "NA"}
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="pr-pf-detail-table-update justify-between">
                <div className="flex w-full">
                  <div className="pr-pf-detail-box-update w-full">
                    <div className="pr-pf-detail-label text-black">
                      Personal Email ID*
                    </div>
                    <div className="pr-pf-input-box">
                      <CustomInput
                        editable={
                          userDetailsResponse?.user_details?.personal_email_id
                            ?.editable
                        }
                        value={personalEmailID}
                        placeholder="Personal Email ID"
                        styles={{ width: "100%" }}
                        onChange={(value) => {
                          setPersonalEmailID(value);
                        }}
                        validationStr={
                          commonFields.user_details.personal_email_id.regex
                        }
                        errorlabel="Email ID"
                        isError={isValidError}
                        isRequired={
                          commonFields.user_details.personal_email_id.required
                        }
                      />
                    </div>
                  </div>
                  <div className="pr-pf-detail-box-update w-full">
                    <div className="pr-pf-detail-label text-black">
                      Personal Mobile Number*
                    </div>
                    <div className="pr-pf-input-box flex gap-2">
                      <div className="input-left">
                        <img
                          src={India}
                          alt=""
                          width="22px"
                          height="14px"
                          className="india-image"
                        />
                        <span className="country-code">+91</span>
                      </div>
                      <div className="input-right">
                        <CustomInput
                          editable={
                            userDetailsResponse?.user_details
                              ?.personal_mobile_no?.editable
                          }
                          value={personalMobileNumber}
                          placeholder="Personal Mobile Number"
                          styles={{ width: "100%" }}
                          onChange={(value) => {
                            setPersonalMobileNumber(value);
                          }}
                          validationStr={
                            commonFields.user_details.personal_mobile_no.regex
                          }
                          errorlabel="Mobile Number"
                          isError={isValidError}
                          isRequired={
                            commonFields.user_details.personal_mobile_no
                              .required
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="pf-pr-box">
            <div className="pf-pr-head">
              <div className="pf-pr-text">Address Details</div>
            </div>
            <div className="pr-pf-detail-table">
              <div className="flex w-full">
                <InfoInput
                  updateInfo={updateInfo}
                  editable={
                    userDetailsResponse?.user_details?.line_1_address?.editable
                  }
                  value={addressLine1}
                  placeholder="Current Address Line 1"
                  styles={{ width: "100%" }}
                  onChange={(value) => {
                    setAddressLine1(value);
                  }}
                  validationString={
                    commonFields.user_details.line_1_address.regex
                  }
                  errorLabel="Address"
                  isValidError={isValidError && !addressLine1}
                />

                <InfoInput
                  updateInfo={updateInfo}
                  editable={
                    userDetailsResponse?.user_details?.line_2_address?.editable
                  }
                  value={addressLine2}
                  placeholder="Current Address Line 2"
                  styles={{ width: "100%" }}
                  onChange={(value) => {
                    setAddressLine2(value);
                  }}
                  validationString={
                    commonFields.user_details.line_2_address.regex
                  }
                  errorLabel="Address"
                  isValidError={isValidError && !addressLine2}
                />

                <InfoInput
                  updateInfo={updateInfo}
                  editable={
                    userDetailsResponse?.user_details?.pincode?.editable
                  }
                  value={addressPincode}
                  placeholder="Current Pincode"
                  styles={{ width: "100%" }}
                  onChange={(value) => {
                    setAddressPincode(value);
                  }}
                  validationString={commonFields.user_details.pincode.regex}
                  errorLabel="Address"
                  isValidError={isValidError && !addressPincode}
                />

                <InfoDropdown
                  options={Country.getAllCountries()}
                  updateInfo={updateInfo}
                  editable={
                    userDetailsResponse?.user_details?.address_country?.editable
                  }
                  value={addressCountry.name}
                  placeholder="Current Country"
                  styles={{ width: "100%" }}
                  onSelect={(value) => {
                    setAddressCountry(value);
                  }}
                  keyName={"name"}
                  isObjectDrop={true}
                  isValidError={isValidError && !addressCountry?.name}
                />
              </div>

              <div className="flex w-full">
                <InfoDropdown
                  options={State.getStatesOfCountry(addressCountry?.isoCode)}
                  updateInfo={updateInfo}
                  editable={userDetailsResponse?.user_details?.state?.editable}
                  value={addressState.name}
                  placeholder="Current State"
                  styles={{ width: "100%" }}
                  onSelect={(value) => {
                    setAddressState(value);
                  }}
                  keyName={"name"}
                  isObjectDrop={true}
                  isValidError={isValidError && !addressState?.name}
                />

                <InfoInput
                  updateInfo={updateInfo}
                  editable={userDetailsResponse?.user_details?.city?.editable}
                  value={addressCity}
                  placeholder="Current City"
                  styles={{ width: "100%" }}
                  onChange={(value) => {
                    setAddressCity(value);
                  }}
                  validationString={commonFields.user_details.city.regex}
                  errorLabel="Current City"
                  isValidError={isValidError && !addressCity}
                />
              </div>
            </div>
          </div>
          {jobDetails && jobDetails?.length !== 0 && (
            <div className="pf-pr-box">
              <div className="pf-pr-head">
                <div className="pf-pr-text">Work Experience</div>
              </div>

              {jobDetails &&
                jobDetails?.map((item, index) => {
                  return (
                    <div className="pr-pf-detail-table" key={index}>
                      <div className="flex w-full">
                        <div className="pr-pf-detail-box">
                          <div className="pr-pf-detail-label">Company Name</div>
                          <div className="pr-pf-detail-value">
                            {item?.company_name}
                          </div>
                        </div>
                        <div className="pr-pf-detail-box">
                          <div className="pr-pf-detail-label">Job Title</div>
                          <div className="pr-pf-detail-value">
                            {item?.job_title}
                          </div>
                        </div>
                        <div className="pr-pf-detail-box">
                          <div className="pr-pf-detail-label">Job Location</div>
                          <div className="pr-pf-detail-value">
                            {item?.job_location}
                          </div>
                        </div>
                        <div className="pr-pf-detail-box">
                          <div className="pr-pf-detail-label">Start Date</div>
                          <div className="pr-pf-detail-value">
                            {item?.start_date}
                          </div>
                        </div>
                      </div>
                      <div className="flex  w-full">
                        <div className="pr-pf-detail-box">
                          <div className="pr-pf-detail-label">End Date</div>
                          <div className="pr-pf-detail-value">
                            {item?.end_date}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
          )}
        </div>
      )}
    </div>
  );
};
export default React.memo(Profile);
